import { render, staticRenderFns } from "./classDetails.vue?vue&type=template&id=0fb51460&scoped=true&"
import script from "./classDetails.vue?vue&type=script&lang=js&"
export * from "./classDetails.vue?vue&type=script&lang=js&"
import style0 from "./classDetails.vue?vue&type=style&index=0&id=0fb51460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb51460",
  null
  
)

export default component.exports